/*
  This utility does two things: 1) Always returns a list of class names ready to be placed into the "className" property 2) Sometimes scopes class names to the component.
  It is a TypeScript version of a function originally copied from https://github.com/JedWatson/classnames/blob/master/index.js
*/
function classNames() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var classes = [];
    /*
      If javascript is not in strict mode, `this` equals `window`. Unless it's been set via `bind`, `call` or `apply`.
      If the function has not been called with any of the methods above, i.e. `classNames.bind(definedThisValue)`, `this.?[arg]` could return a value from the window object (if the class name matches a property on the window object).
      To avoid this problem, we set `_this` equal to undefined if `this === window`.
    */
    var _this = typeof window !== 'undefined' && this === window ? undefined : this;
    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
        var arg = args_1[_a];
        if (!arg) {
            // eslint-disable-next-line no-continue
            continue;
        }
        var argType = typeof arg;
        if (argType === 'string') {
            var argStrToArray = arg.split(' ');
            if (_this && argStrToArray.length > 1) {
                // If multiple classes passed in a string, handle them as an array
                classes.push(classNames.apply(_this, argStrToArray));
            }
            else {
                classes.push((_this === null || _this === void 0 ? void 0 : _this[arg]) || arg); // If _this exists, the class will be scoped to its component
            }
        }
        else if (Array.isArray(arg)) {
            [].concat.apply([], arg).filter(Boolean).length && classes.push(classNames.apply(_this !== null && _this !== void 0 ? _this : null, arg)); // Filter out empty, undefined, false arrays/array values and then check the length
        }
        else if (argType === 'object') {
            if (arg.toString === Object.prototype.toString) {
                for (var key in arg) {
                    // eslint-disable-next-line max-depth
                    if ({}.hasOwnProperty.call(arg, key) && arg[key]) {
                        classes.push((_this === null || _this === void 0 ? void 0 : _this[key]) || key); // If _this exists, the class will be scoped to its component
                    }
                }
            }
            else {
                classes.push(arg.toString());
            }
        }
    }
    return classes.join(' ');
}

export { classNames };
